import { styled } from '@mui/material/styles';
import { SmsIcon, WhatsAppIcon, EmailIcon, LiveChatIcon, MessengerIcon, InstagramIcon } from 'assets/images/channels';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import { CHANNEL } from '@constants/channels';

const StyledSvgWrapper = styled('span')({
    '& svg path': {
        fill: 'var(--primary-main)',
    },
});

export const getChannelIcon = type => {
    switch (type) {
        case 0:
            return <SmsIcon />;
        case 1:
        case 7:
            return <WhatsAppIcon />;
        case 2:
            return <EmailIcon />;
        case 4:
            return <LiveChatIcon />;
        case 5:
            return <MessengerIcon />;
        case 6:
            return <InstagramIcon />;
        case null:
            return (
                <StyledSvgWrapper>
                    <DeleteIcon sx={{ fontSize: 18 }} />
                </StyledSvgWrapper>
            );
        default:
            return null;
    }
};

export const getConversationChannelIcon = conversation =>
    getChannelIcon(conversation?.channelId === CHANNEL.ARCHIVED ? CHANNEL.ARCHIVED : conversation?.channelType);

export const getChannelLinkScope = ({ locationId, brandId }, locations) => {
    if (locationId) {
        const locationBrandId = locations.find(location => location.companyId === locationId)?.brand?.id;
        return { locationIds: [locationId], brandIds: locationBrandId ? [locationBrandId] : [] };
    }
    if (brandId) {
        return {
            locationIds: locations
                .filter(location => location.brand?.id === brandId)
                .map(location => location.companyId),
            brandIds: [brandId],
        };
    }
    return null;
};

export const isChannelInLinkScope = (channel, scope) =>
    !scope ||
    (!channel.locationId && !channel.brandId) ||
    scope.locationIds.includes(channel.locationId) ||
    scope.brandIds.includes(channel.brandId);

export const liveChatFollowUpContactField = (liveChat, channelsById) => {
    const params = liveChat?.liveChatParameters;
    if (params?.useDefaultEmailChannel) return 'email';
    const followUp = channelsById[params?.followUpChannelId];
    if (!followUp) return null;
    return followUp.type === CHANNEL.EMAIL ? 'email' : 'phone';
};

export const assignsLiveChatLocation = channel =>
    channel?.type === CHANNEL.LIVE_CHAT && !!channel.liveChatParameters?.assignLocation;

export const liveChatServesLocation = (channel, location) => {
    if (!assignsLiveChatLocation(channel) || !location) return false;
    const listed = channel.liveChatParameters.locations || [];
    if (listed.length && !listed.includes(location.companyId)) return false;
    return channel.brandId ? location.brand?.id === channel.brandId : listed.length > 0;
};

export const isSameChannelLink = (channel, { locationId, brandId }) =>
    !!channel &&
    (channel.locationId || null) === (locationId || null) &&
    (channel.brandId || null) === (brandId || null);
